export default {
      id: "camera-offline-usage",
      viewBox: "0 0 23 23",
      url: __webpack_public_path__ + "img/icons.svg#camera-offline",
      toString: function () {
        return this.url;
      }
    }